import dayjs from "dayjs";
import { Direction, ICalendarDay, IPassengerType, ISearchState, IStop, maxPassengerCount } from "../Models";
import { SearchActionType } from "./Actions";
import { BookingDialogActionType } from "../Actions";

export const createS3SearchReducer = (initialState: any = null) => {

	initialState = setInitialState(initialState);

	return (state: ISearchState = initialState, action: { type?: SearchActionType|BookingDialogActionType }): ISearchState => {
		switch(action.type) {
			case "showDialog":
				return showDialog(state, action as any);
			case "loadStopsComplete":
				return { ...state, ...{ stops: (action as any).payload.items }};
			case "loadPassengerTypesComplete":
				return { ...state, ...{ passengerTypes: (action as any).payload.items }}; //TODO: Välj initial passagerare också
			case "loadCalendarComplete":
					return calendarLoaded(state, (action as any).payload, (action as any).meta);
			case "setOrigin":
				return { ...state, ...{ origin: (action as any).stop }};
			case "setDestination":
				return { ...state, ...{ destination: (action as any).stop }};
			case "setTwoWay":
				return { ...state, ...{ isTwoWay: (action as any).isTwoWay }};
			case "setDepartureDate":
				return updateDepartureDate(state, (action as any).date);
			case "setReturnDate":
				return updateReturnDate(state, (action as any).date);
			case "addPassenger":
				return addPassenger(state);
			case "removePassenger":
				return removePassenger(state, (action as any).index);
			case "setPassengerType":
				return setPassengerType(state, (action as any));
			case "setTravelWithPet":
				return { ...state, ...{ travelWithPet: (action as any).travelWithPet }};
			case "setInterrail":
				const interrailChecked = (action as any).interrail as boolean;
				return { ...state, ...{ interrail: interrailChecked, interrailValidation: interrailChecked ? state.interrailValidation : undefined }};
			case "valideraInterrailComplete":
				return { ...state, ...{ interrailValidation: (action as any).payload }};
			default:
				return state;
		}
	};

	function setInitialState(initialState?: ISearchState): ISearchState {
		const defaultState = {
			isTwoWay: true,
			departureDate: dayjs().format("YYYY-MM-DD"),
			passengerTypes: [
				{ code: "AD", description: "Adult" }
			],
			passengers: [
				{ type: { code: "AD", description: "Adult" } }
			],
			travelWithPet: false
		} as ISearchState;

		if (!initialState)
			return defaultState;

		//Specialare -- om vi skickar med departureDate men INTE returnDate i initialState ska det bli en enkelresa
		if (initialState.departureDate && !initialState.returnDate)
			initialState = { ...initialState, ...{ isTwoWay: false } };

		return {...defaultState, ...initialState};
	}
};

function showDialog(state: ISearchState, action: { search: { origin?: IStop, destination?: IStop } }) : ISearchState {
	if (action.search) {
		const origin = action.search.origin || state.origin;
		const destination = action.search.destination || state.destination;

		return { ...state, ...{ origin, destination } };
	}

	return state;
}

function updateDepartureDate(state: ISearchState, date?: string) : ISearchState
{
	if (date && dayjs().isAfter(date, "day"))
		return state;

	return { ...state, ...{ departureDate: date }};
}

function updateReturnDate(state: ISearchState, date?: string) : ISearchState
{
	if (date && state.departureDate && dayjs(date).isBefore(state.departureDate, "day"))
		return state;

	return { ...state, ...{ returnDate: date }};
}

function addPassenger(state: ISearchState) : ISearchState
{
	if (state.passengers?.length >= maxPassengerCount)
		return state;

	const passengers = [...state.passengers];
	passengers.push({ type: state.passengerTypes[0] });
	return { ...state, ...{ passengers }};
}

function removePassenger(state: ISearchState, index: number) : ISearchState
{
	if (!state.passengers || state.passengers.length === 0)
		return state;

	const passengers = [...state.passengers];
	passengers.splice(index, 1);
	return { ...state, ...{ passengers }};
}

function setPassengerType(state: ISearchState, action: { index: number, passengerType: IPassengerType }) : ISearchState
{
	if (!(state.passengers?.length > action.index))
		return state;
	const passengers = [...state.passengers];
	passengers[action.index] = { ...passengers[action.index], ...{ type: action.passengerType }};
	return { ...state, ...{ passengers }};
}

function calendarLoaded(state: ISearchState, payload: { calendar: {[key: string]: ICalendarDay }}, meta: { direction: Direction, origin: string, destination: string }) : ISearchState
{
	const currentCalendar = meta.direction === "outbound" ? state.outboundCalendar : state.inboundCalendar;

	const newCalendar =  { days: payload.calendar, origin: meta.origin, destination: meta.destination };

	if (!currentCalendar || currentCalendar.origin !== meta.origin || currentCalendar.destination !== meta.destination)
		return meta.direction === "outbound" ?
			{ ...state, ...{ outboundCalendar: newCalendar } } :
			{ ...state, ...{ inboundCalendar: newCalendar } }

	const mergedCalendar = { ...currentCalendar };
	mergedCalendar.days = {...mergedCalendar.days,...newCalendar.days };
	return meta.direction === "outbound" ?
		{ ...state,...{ outboundCalendar: mergedCalendar } } :
		{...state,...{ inboundCalendar: mergedCalendar } };
}
